<template>
    <b-modal id="ResetPassword" centered size="lg" ref="resetPasswordModal" class="modal-backdrop" no-close-on-esc
        no-close-on-backdrop>
        <template slot="modal-header" class="mx-auto">
            <h5 class="modal-title" style="text-align:center;">Reset Password</h5>
        </template>
        <template slot="default">
            <p style="background-color:#fae5e3;">
                An email will be sent to the user's email containing verification/reset password link.
                <br />
                Note:The user's password will not be changed until they provide a new password through the reset password
                link.
            </p>
            <p>
                <!--<span class="errorMessage" v-if="$v.form.$error">Reason cannot be blank.</span>-->
            </p>
            <div class="container">
                <div class="form-group row">
                    <label for="inputEmail3"
                        class="col-md-2 col-form-label"><!--<span class="requiredinput">*</span>-->Reason:</label>
                    <div class="col-md-10">
                        <textarea style="width:312px !important; resize:none;" v-model="form.reason" v-sanitize-html="form.reason" />
                    </div>
                </div>
            </div>

        </template>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button class="um-btn" @click="cancelChanges()">Cancel</b-button>
            <b-button class="um-btn" @click="resetUserPassword()">Submit</b-button>
        </template>
        <InfoPopup :popupmessage="info.message"></InfoPopup>
        <loading :active.sync="isLoading" :can-cancel="true"></loading>
        <ErrorMessage :errorMessage="error" callbackOnClose></ErrorMessage>
    </b-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import service from "../../services/api.services";
import InfoPopup from "./InfoPopup";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { eventbus } from "../../main";
import ErrorMessage from "./ErrorMessage";

export default {
    name: "ResetPassword",
    components: {
        InfoPopup,
        Loading,
        ErrorMessage
    },
    data() {
        return {
            form: {
                reason: ""
            },
            info: { message: "" },
            isLoading: false,
            error: ""
        };
    },
    validations: {
        form: {
            reason: { required }
        }
    },
    props: {
        userDetail: {}
    },
    mounted() {
        var that = this;
        eventbus.$on("confirmOkChanges", function () {
            that.okChanges();
        });
    },
    methods: {
        clearForm: function () {
            this.form.reason = "";
            //this.$v.form.$reset();
        },
        okChanges: function () {
            this.$bvModal.hide("infopopup");
            if (typeof this.$refs["resetPasswordModal"] !== "undefined")
                this.$refs["resetPasswordModal"].hide();
            this.clearForm();
        },
        cancelChanges: function () {
            this.$refs["resetPasswordModal"].hide();
            this.clearForm();
        },

        resetUserPassword: function () {

            this.resetPassword()
        },

        async resetPassword() {
            var that = this
            that.isLoading = true;
            await service.ResetUserPassword({ userDetail: this.userDetail, passwordResetReason: (this.form.reason) })
                .then(response => {
                    if (response.data.isPasswordChanged == true) {
                        that.isLoading = false;
                        that.info.message = "Password Reset email is sent successfully";
                        that.$bvModal.show("infopopup");
                    }
                    else {
                        that.error = "error occured while sending Password Reset email."
                        that.$bvModal.show("errormessage");
                        that.isLoading = false;
                    }
                    that.form.reason = "";
                })
                .catch(error => {
                    that.isLoading = false;
                    console.log("api error:" + error);
                });

        },
    }
}
</script>
<style>
.requiredinput {
    color: red;
}

.hasError label {
    color: red !important;
}

.hasError input {
    border-color: red !important;
}

.noError input {
    border-color: white !important;
}

.modal-backdrop {
    opacity: 0.5;
    transition: opacity 0.2s;
    border-color: red;
}

.modal-title {
    margin: auto;
}

.errorMessage {
    color: red;
    font-size: 0.8em;
    font-weight: 500;
}
</style>
